import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles'
import { FormattedMessage } from 'react-intl';

import Loader from '../../../components/Loader';
import School from '../../../components/School';
import { withRtl } from '../../../components/hoc';
import messages from '../../../locale/messages';
import style from './ScheduleDetail.scss';

class ScheduleDetail extends React.PureComponent {
  showSchoolDetail = (directorySchoolId, directoryProgramId) => {
    this.props.showSchoolDetail(directorySchoolId, directoryProgramId);
  };

  renderDetails = () => {
    const {
      programs,
      school,
      directoryProgramId,
      programClick,
      programsLoading,
      initScheduling,
      user,
      removeNoMatchingTimeSlot,
    } = this.props;

    if (programsLoading) {
      return <Loader />;
    }

    return (
      <School
        {...school}
        firstName={user.firstName}
        loggedIn
        onClick={directorySchoolId => this.showSchoolDetail(directorySchoolId, directoryProgramId)}
        showDetails
        programOpen={this.props.detailShowsSchool ? null : directoryProgramId}
        programClick={programClick}
        scheduleProgram={programs.result.find(program => program.directory_program.id === directoryProgramId)}
        initScheduling={initScheduling}
        headerOpen={this.props.detailShowsSchool}
        removeNoMatchingTimeSlot={removeNoMatchingTimeSlot}
      />
    );
  };

  render() {
    const { isRtl, showProgramList } = this.props;

    return (
      <div className={style.scheduleDetailContainer}>
        <div>
          <button className={classNames('button', style.scheduleDetailBackButton)} onClick={showProgramList}>
            <span>
              <i className={`icon-${isRtl ? 'right' : 'left'}`} />
            </span>
            <span>
              <FormattedMessage {...messages.generalStringBackToList} />
            </span>
          </button>
        </div>
        {this.renderDetails()}
      </div>
    );
  }
}

ScheduleDetail.defaultProps = {
  isRtl: false,
  detailShowsSchool: false,
};

ScheduleDetail.propTypes = {
  programs: PropTypes.shape().isRequired,
  school: PropTypes.shape().isRequired,
  directoryProgramId: PropTypes.number.isRequired,
  user: PropTypes.shape().isRequired,
  isRtl: PropTypes.bool,
  initScheduling: PropTypes.func.isRequired,
  removeNoMatchingTimeSlot: PropTypes.func.isRequired,
  showProgramList: PropTypes.func.isRequired,
  showSchoolDetail: PropTypes.func.isRequired,
  programClick: PropTypes.func.isRequired,
  programsLoading: PropTypes.bool.isRequired,
  detailShowsSchool: PropTypes.bool,
};

export default withRtl(style)(withStyles(style)(ScheduleDetail));
